enum FileStatus {
  Uploaded = 'UPLOADED',
  Processing = 'PROCESSING',
  DataReady = 'DATA_READY',
  Failed = 'FAILED',
}

export default FileStatus;
